import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { Col } from "antd";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { unblockCompany } from "services";
import { HTMLAttributes } from "react";

export const UnblockCompanyButton: React.FC<HTMLAttributes<HTMLElement>> = observer(({ ...props }) => {
  const { actionModals, companyCard } = useStores();

  const clickHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Вы действительно хотите восстановить компанию?"
          successText="Компания активирована, учетные записи пользователей требуется активировать дополнительно"
          buttonText="Восстановить"
          calledQuery={() => unblockCompany({ id: companyCard.card.id })}
          onSuccess={() => {
            setTimeout(() => companyCard.updateCardById(companyCard.card.id), 1500);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <Col className={props.className}>
      <CustomButton type="default" onClick={clickHandler} tooltip="Восстановить компанию">
        Восстановить
      </CustomButton>
    </Col>
  );
});
